import React from 'react';

interface CheckboxIconProps {
  width?: number;
  height?: number;
  checked?: boolean;
  color?: string;
  checkedColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

const CheckboxIcon: React.FC<CheckboxIconProps> = ({ 
  width = 16, 
  height = 16, 
  checked = false,
  color = '#293044',
  checkedColor = '#FF6F0F',
  className,
  style 
}) => {
  if (checked) {
    // 선택된 체크박스 (오렌지색 원에 체크)
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={width} 
        height={height} 
        viewBox="0 0 16 16"
        fill="none"
        className={className}
        style={style}
      >
        <circle cx="8" cy="8" r="7" fill={checkedColor} />
        <path 
          d="M5 8L7 10L11 6" 
          stroke="white" 
          strokeWidth="1.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    );
  } else {
    // 선택 안된 체크박스 (빈 원 또는 회색 원)
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={width} 
        height={height} 
        viewBox="0 0 16 16"
        fill="none"
        className={className}
        style={style}
      >
        <circle cx="8" cy="8" r="7" stroke={color} strokeWidth="1.2" />
      </svg>
    );
  }
};

export default CheckboxIcon;

